import { HttpError } from "@nestia/fetcher";
import api from "@api";
import { getConnection } from "@app/sdk";

const extractServerMessage = (e: HttpError): string | null => {
  try {
    const body = JSON.parse(e.message) as { message?: string };
    return body.message ?? null;
  } catch {
    return null;
  }
};

export const respondToInvitation = async (
  token: string,
  action: "accept" | "decline",
): Promise<void> => {
  try {
    await api.functional.invitations.respondToInvitation(
      getConnection(),
      token,
      { action },
    );
  } catch (e) {
    if (e instanceof HttpError) {
      throw new Error(
        extractServerMessage(e) ?? "Failed to respond to invitation",
      );
    }
    throw e;
  }
};
